<ng-container *ngIf="isBusy">
  <span class="circle provisioning"></span>
</ng-container>

{{value}}
